import React from "react";

import { Hero } from "../components/Hero";
import CardsSection from "../components/CardsSection";
import { InfoSection } from "../components/InfoSection";
import MapaPeru from "../components/MapaPeru";
import { FAQ } from "../components/FAQ";
import { Form } from "../components/Form";

export default function Home() {
  return (
    <>
      {" "}
      <section id="inicio">
        {" "}
        <Hero />{" "}
      </section>
      <section id="publicaciones">
        <InfoSection />
      </section>
      <section id="formacion">
        <CardsSection />
      </section>
      <section id="proyectos">
        <MapaPeru />
      </section>
      
      <section id="contacto">
        <Form />
      </section>
    </>
  );
}
